import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-red.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex items-center justify-between flex-row w-full" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "font-semibold text-sm" }
const _hoisted_5 = { class: "font-semibold text-sm px-1" }
const _hoisted_6 = {
  key: 0,
  class: "absolute top-full left-0 bg-white rounded-b-lg shadow-lg z-50 w-300px border border-gray-lp-200"
}
const _hoisted_7 = { class: "p-4 space-y-4" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_14 = { class: "flex items-center justify-between p-4 border-t border-gray-lp-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LastLocationFilterSection = _resolveComponent("LastLocationFilterSection")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: ["flex items-center px-4 py-2 bg-white border transition-colors duration-200", [
        _ctx.isOpen ? ' w-300px rounded-t-md' : ' w-100px rounded-md',
        _ctx.filterCount > 0
          ? 'bg-red-lp-1300 border-red-lp-300 text-red-lp-100'
          : 'bg-white border-gray-lp-400'
      ]],
      "data-testid": "urgent-rts-filter-toggle",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.filter")), 1),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.filterCount > 0 ? `(${_ctx.filterCount})` : ""), 1)
        ]),
        (_ctx.filterCount === 0)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: 
            `${
              _ctx.isOpen ? 'rotate-180' : 'rotate-0'
            } transition-transform duration-200 w-5 h-5`
          
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: 
            `${
              _ctx.isOpen ? 'rotate-180' : 'rotate-0'
            } transition-transform duration-200 w-5 h-5`
          
            }, null, 2))
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.caseType")), 1),
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.tempParameters.caseType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tempParameters.caseType = $event)),
                selectedItem: _ctx.tempParameters.caseType,
                options: _ctx.caseTypeData,
                placeholder: _ctx.$t('urgentDeliveryManagement.filter.selectCaseType'),
                class: "w-full",
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTempFilter($event, 'caseType')))
              }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.deliveryType")), 1),
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.tempParameters.productType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tempParameters.productType = $event)),
                selectedItem: _ctx.tempParameters.productType,
                options: _ctx.productTypeOptions,
                placeholder: 
              _ctx.$t('urgentDeliveryManagement.filter.selectDeliveryType')
            ,
                class: "w-full",
                onSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTempFilter($event, 'productType')))
              }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.sttType")), 1),
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.tempParameters.sttClientAggregatorType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.tempParameters.sttClientAggregatorType = $event)),
                selectedItem: _ctx.tempParameters.sttClientAggregatorType,
                options: _ctx.aggregatorTypeOptions,
                placeholder: _ctx.$t('urgentDeliveryManagement.filter.selectSttType'),
                class: "w-full",
                onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTempFilter($event, 'sttClientAggregatorType')))
              }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
            ]),
            _createVNode(_component_LastLocationFilterSection, {
              modelValue: _ctx.tempLastLocation,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.tempLastLocation = $event)),
              ref: "lastLocationFilterRef",
              options: _ctx.options,
              testIdPrefix: "urgent-rts"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("button", {
              "data-testid": "urgent-rts-filter-reset",
              class: "text-red-lp-100 font-semibold text-sm px-6 hover:underline",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
            }, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.reset")), 1),
            _createVNode(_component_lp_button, {
              title: _ctx.$t('urgentDeliveryManagement.filter.apply'),
              "data-testid": "urgent-rts-filter-apply",
              customClass: "w-auto px-6",
              textColor: "white",
              small: "",
              disabled: _ctx.isApplyDisabled,
              onClick: _ctx.applyFilter
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.closeFilter]
  ])
}